type Base64 = string | ArrayBuffer | null;

export const blobToBase64 = (blob: Blob): Promise<Base64> => {
  return new Promise<Base64>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
  });
};

export const base64ToBlob = (base64data: string): Blob => {
  const mimeType = base64data.split(",")[0].split(":")[1].split(";")[0];

  const byteCharacters = atob(base64data.split(",")[1]);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};

export const getAudioType = (type: string): string => {
  return type.split("/")[1];
};

export const getBlobDurationInSecs = (blob: any) => {
  return new Promise<number>((resolve, reject) => {
    const audio = new Audio();
    const objectURL = URL.createObjectURL(blob);

    audio.addEventListener("loadedmetadata", () => {
      resolve(audio.duration);
      URL.revokeObjectURL(objectURL);
    });
    audio.addEventListener("error", (e) => {
      URL.revokeObjectURL(objectURL);
      reject("Audio file is corrupted");
    });
    audio.src = objectURL;
  });
};

export const formatBlobDuration = (seconds: number) => {
  const roundedSeconds = Math.floor(seconds);

  const minutes = Math.floor(roundedSeconds / 60);
  const remainingSeconds = roundedSeconds % 60;

  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");

  return `${formattedMinutes}:${formattedSeconds}`;
};
